export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <span className="block w-8 h-0.5 bg-accent"></span>
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">About Us</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden aspect-[4/5] w-full max-w-sm mx-auto lg:mx-0">
              <img
                src="https://public.readdy.ai/ai/img_res/06134c590124578d926c33fd1aacd890.jpg"
                alt="Precision North Home Inspections owner"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay card */}
              <div className="absolute bottom-0 left-0 right-0 bg-navy/90 backdrop-blur-sm px-6 py-4">
                <p className="text-white font-heading font-semibold text-lg leading-tight">Precision North</p>
                <p className="text-accent-light text-sm font-medium">Home Inspections</p>
                <div className="flex items-center gap-1.5 mt-1">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-2-fill text-white/60 text-xs"></i>
                  </div>
                  <span className="text-white/60 text-xs">Gaylord, Michigan</span>
                </div>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-accent-muted rounded-lg -z-10 hidden lg:block"></div>
          </div>

          {/* Text Side */}
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy leading-tight mb-6">
              Meet Precision North Home Inspections
            </h2>

            <p className="text-gray-600 text-base leading-relaxed mb-5">
              We&apos;re a locally owned and operated home inspection company proudly based in <strong>Gaylord, Michigan</strong>, serving homebuyers, sellers, and homeowners throughout Northern Michigan and Up North communities.
            </p>

            <p className="text-gray-600 text-base leading-relaxed mb-5">
              At Precision North, we believe every client deserves honest answers and a clear picture of their property. Whether you&apos;re purchasing your first home, preparing to sell, or simply want to understand the condition of your current property, we&apos;re here to give you the thorough, professional service you deserve.
            </p>

            <p className="text-gray-600 text-base leading-relaxed mb-8">
              <em>[Owner bio placeholder &mdash; replace with a personal introduction, your background, certifications, and what motivates you to serve Northern Michigan homeowners.]</em>
            </p>

            {/* Stats / Highlights */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: 'ri-shield-check-line', label: 'Certified Inspector', sub: 'Fully Licensed & Insured' },
                { icon: 'ri-map-pin-line', label: 'Northern Michigan', sub: 'Gaylord & Surrounding Areas' },
                { icon: 'ri-file-list-3-line', label: 'Clear Reports', sub: 'Easy-to-Read Findings' },
                { icon: 'ri-customer-service-2-line', label: 'Personal Service', sub: 'Direct Owner Contact' },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3 p-4 bg-surface rounded-lg">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-muted rounded-md flex-shrink-0">
                    <i className={`${item.icon} text-accent text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-navy font-semibold text-sm">{item.label}</p>
                    <p className="text-gray-500 text-xs mt-0.5">{item.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
